import OrganizationListItem from './OrganizationListItem';

export default OrganizationListItem;
